<script setup lang="ts">
const route = useRoute();
const selectedOffset = ref(0);

const { data: players } = useFetch("/api/search", {
  query: {
    event: route.params.id,
    offset: selectedOffset,
  },
});
const armyListModal = ref(false);
const selectedPlayer = ref();
const playerTable = ref();
</script>

<template>
  <div class="section">
    <div v-if="players && players.length > 0">
      <h1>{{ players?.[0]?.event_name }}</h1>
      <table class="table is-striped is-hoverable mainplayer" ref="playerTable">
        <thead>
          <tr>
            <th>Faction</th>
            <th>Player</th>
            <th>Record</th>
            <th>Players</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="player in players"
            :key="player.player_bcp_id"
            @click="
              armyListModal = true;
              selectedPlayer = player;
            "
          >
            <td>
              {{ player.parsed_faction }}
            </td>
            <td>
              {{ player.player_name }}
            </td>
            <td style="white-space: nowrap">
              {{ player.wins }} -
              {{ player.losses }}
              {{ player.draws > 0 ? " - " + player.draws : "" }}
            </td>
            <td>
              {{ player.players }}
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <button class="button is-primary" @click="selectedOffset = 0">
          First
        </button>
        <button
          class="button is-primary"
          @click="
            playerTable.scrollIntoView({ behavior: 'smooth' });
            selectedOffset += 50;
          "
        >
          Next
        </button>
      </div>

      <Dialog
        v-model:visible="armyListModal"
        modal
        dismissableMask
        blockScroll
        :draggable="false"
        :header="
          selectedPlayer?.player_name + ' - ' + selectedPlayer?.event_name
        "
      >
        <ListView :player="selectedPlayer" />
      </Dialog>
    </div>
    <div v-else>No player lists were found for this event.</div>
  </div>
</template>
